<template>
  <div class="apply" :style="{ minHeight: height + 'px' }">
    <div class="top">
      <Sticky>
        <Header></Header>
      </Sticky>

      <div class="form">
        <p class="moduleTitle">{{ $t('appointment.visited.info') }}</p>
        <FormItem :label="$t('appointment.visited.name')">
          <Input
            type="text"
            v-model="info.visitorInterviewee.name"
            :placeholder="$t('appointment.visited.name.tips')"
            @blur="getVisitorType"
          />
        </FormItem>

        <FormItem :label="$t('appointment.visited.number')">
          <!-- type="number" -->
          <Input
            type="text"
            v-model="info.visitorInterviewee.workNum"
            :placeholder="$t('appointment.visited.number.tips')"
            @blur="getVisitorType"
          />
        </FormItem>

        <p class="moduleTitle">{{ $t('appointment.visiting.info') }}</p>

        <FormItem :label="$t('appointment.visiting.company')">
          <Input
            type="text"
            v-model="info.visitorInfoExtra.company"
            :placeholder="$t('appointment.visiting.company.tips')"
          />
        </FormItem>

        <FormItem :label="$t('appointment.visiting.reason')">
          <Input
            type="text"
            v-model="info.visitorInfoExtra.reason"
            :placeholder="$t('appointment.visiting.reason.tips')"
          />
          <!-- <BottomSelect
            :columns="reasonList"
            :value.sync="info.visitorInfoExtra.reason"
            :placeholder="$t('appointment.visiting.reason.tips')"
          /> -->
        </FormItem>

        <FormItem :label="$t('appointment.visiting.area')" arr="true">
          <BottomAreaSelect
            :columns="areaList"
            :value.sync="info.visitorInfoExtra.deviceGroupId"
            :placeholder="$t('appointment.visiting.area.tips')"
          />
        </FormItem>

        <FormItem :label="$t('appointment.visiting.building')" arr="true">
          <BuildingSelect
            :buildinglist="buildingList"
            :value.sync="info.visitorInfoExtra.deviceGroupIds"
            :placeholder="$t('appointment.visiting.building.tips')"
          />
        </FormItem>

        <FormItem :label="$t('appointment.visiting.type')" arr="true">
          <BottomSelect
            :columns="typeList"
            :value.sync="info.visitorInfoExtra.type"
            :placeholder="$t('appointment.visiting.type.tips')"
          />
        </FormItem>

        <FormItem v-if="isPark" :label="$t('appointment.visitors.files')">
          <!-- <FormItem v-if="info.visitorInfoExtra.type === carType" :label="$t('appointment.visitors.files')"> -->
          <UploadFile v-model="info.visitorInfoExtra.identityFile" :isDelete="true" />
        </FormItem>
        <FormItem :label="$t('appointment.visiting.vehicle')">
          <Input
            type="text"
            v-model="info.cars[0].numberPlate"
            :placeholder="isPark ? $t('appointment.visiting.vehicle.tip') : $t('appointment.visiting.vehicle.tips')"
          />
          <!-- <Input
            type="text"
            v-model="info.cars[0].numberPlate"
            :placeholder="
              info.visitorInfoExtra.type === carType
                ? $t('appointment.visiting.vehicle.tip')
                : $t('appointment.visiting.vehicle.tips')
            "
          /> -->
        </FormItem>
        <!-- <InputList
          v-else
          :type="info.visitorInfoExtra.type"
          v-model="info.cars"
          :placeholder="$t('appointment.visiting.vehicle.tips')"
        /> -->

        <FormItem :label="$t('appointment.visiting.things')">
          <Input
            type="text"
            v-model="info.visitorInfoExtra.belongings"
            :placeholder="$t('appointment.visiting.things.tips')"
          />
        </FormItem>

        <FormItem v-if="!isPark" :label="$t('visitor.apply.time.start')" arr="true">
          <!-- <FormItem v-if="info.visitorInfoExtra.type !== carType" :label="$t('visitor.apply.time.start')" arr="true"> -->
          <HourSelect :placeholder="$t('appointment.visiting.start.tips')" :value.sync="info.visitorInfoExtra.begin" />
        </FormItem>

        <FormItem v-if="!isPark" :label="$t('visitor.apply.time.end')" arr="true">
          <!-- <FormItem v-if="info.visitorInfoExtra.type !== carType" :label="$t('visitor.apply.time.end')" arr="true"> -->
          <HourSelect :placeholder="$t('appointment.visiting.end.tips')" :value.sync="info.visitorInfoExtra.end" />
        </FormItem>
        <FormItem v-if="isPark" :label="$t('appointment.visiting.time')">
          <!-- <FormItem v-if="info.visitorInfoExtra.type === carType" :label="$t('appointment.visiting.time')"> -->
          <div @click="goToAddCarsParking" class="visitingCarType" v-if="startTime && endTime">
            <!-- <span class="visitingTime">
              {{ $t('appointment.visiting.time.tips') }}
            </span> -->
            <span class="visitingTime">
              {{ startTime }}{{ ' -' }}
              {{ endTime }}
            </span>
            <p class="visitingPark" v-if="info.cars[0].park !== ''">
              {{ $t('appointment.visitors.parking.space' + +info.cars[0].park) }}
            </p>
          </div>

          <div v-else @click="goToAddCarsParking" class="text-placeholder">
            {{ $t('appointment.visiting.time.tips') }}
          </div>
        </FormItem>

        <p class="moduleTitle addModuleTitle" v-if="!!info.peers.length">{{ $t('appointment.visitors.info') }}</p>

        <VisitorAddon v-model="info.peers" :type="info.visitorInfoExtra.type"></VisitorAddon>
      </div>
      <div class="agreement-wrap">
        <Checkbox v-model="agree" shape="square" checked-color="#00CCBF">
          <a
            @click.stop="
              agreementPopupShow = true;
              agree = true;
            "
          >
            《{{ $t('appointment.visitors.agreementName') }}》
          </a>
        </Checkbox>
      </div>
      <div class="button">
        <Button :disabled="isLoading" color="#00CCBF" @click="submit" block>
          <span class="buttonText">{{ $t('common.submit') }}</span>
        </Button>
      </div>
    </div>

    <AgreementPopup v-model="agreementPopupShow" />
  </div>
</template>

<script>
import moment from 'moment';
import { Button, Notify, Toast, Sticky, Checkbox } from 'vant';
import FormItem from '@/components/formItem';
import Input from '@/components/input.vue';
import BottomSelect from '@/components/bottomSelect.vue';
import BottomAreaSelect from '@/components/bottomAreaSelect';
// import InputList from '@/components/inputList';
import HourSelect from '@/components/hourSelect.vue';
// import Upload from '@/components/upload.vue';
// import Upload from '@/components/visitorUpload.vue';
import UploadFile from '@/components/uploadFile.vue';
import api from '@/services/api';
import Header from '@/components/header.vue';
import VisitorAddon from './addVisitor.vue';
import AgreementPopup from './AgreementPopup';
import BuildingSelect from '@/components/buildingSelect.vue';
import i18n from '@/i18n';

export default {
  components: {
    // Upload,
    UploadFile,
    FormItem,
    Input,
    Button,
    BottomSelect,
    HourSelect,
    Header,
    VisitorAddon,
    BottomAreaSelect,
    BuildingSelect,
    Sticky,
    Checkbox,
    AgreementPopup,
    // InputList,
  },

  data() {
    return {
      info: {
        visitorInterviewee: {
          name: '',
          workNum: '',
          // tel: '',
        },
        visitorInfoExtra: {
          company: '',
          reason: '',
          deviceGroupId: '',
          type: '',
          belongings: '',
          begin: null,
          end: null,
          identityFile: '',
        },
        visitorInfo: {
          name: '',
          photo: '',
          tel: '',
          certificatesType: '',
          certificatesNumber: '',
          socialSecurityFile: '',
          orgId: '',
        },
        peers: [
          {
            name: '',
            photo: '',
            tel: '',
            certificatesType: '',
            certificatesNumber: '',
            socialSecurityFile: '',
          },
        ],
        cars: [
          {
            numberPlate: '',
            park: '',
          },
        ],
      },
      defaultObj: {},
      // areaList: [],
      reasonList: [],
      // typeList: [],

      // defaultType: [],
      carType: this.$t('appointment.visitors.cars.truck'),
      carTypes: [
        this.$t('appointment.visitors.cars.truck_0'),
        this.$t('appointment.visitors.cars.truck_1'),
        this.$t('appointment.visitors.cars.truck_2'),
        this.$t('appointment.visitors.cars.truck_3'),
      ],
      isPark: false,
      isLoading: false,
      agreementPopupShow: false,
      /** 是否同意协议 */
      agree: false,
    };
  },
  computed: {
    authorId() {
      const config = process.env.NODE_ENV === 'development' ? window.config.dev : window.config.prod;
      return config.authorId;
    },

    height() {
      return window.innerHeight - parseInt(document.body.style.fontSize) * 1.17333;
    },
    // authorId() {
    //   return this.$route.query.authorId;
    // },
    initInfo() {
      const infoStore = localStorage.getItem('infoStore');
      return (infoStore && JSON.parse(infoStore)) || {};
    },
    applyInfo() {
      return this.$store.state.visitor.visitorApplyInfo;
    },
    defaultType() {
      return this.$store.state.visitor.visitorDefaultTypeList;
    },
    typeList() {
      return this.$store.state.visitor.visitorTypeList;
    },
    areaList() {
      return this.$store.state.visitor.visitorAreaList;
    },
    buildingList() {
      return this.$store.state.visitor.visitorBuildingList;
    },
    startTime() {
      return this.info.visitorInfoExtra.begin && moment(this.info.visitorInfoExtra.begin).format('YYYY-MM-DD HH:mm');
    },
    endTime() {
      return this.info.visitorInfoExtra.end && moment(this.info.visitorInfoExtra.end).format('HH:mm');
    },
    routerPath() {
      return this.$route.path;
    },
  },

  watch: {
    'info.visitorInfoExtra.type'(val) {
      if (val) {
        this.defaultType && this.isEqual(val);
      }
    },
  },
  async created() {
    if (!this.authorId) return;
    this.defaultObj = this.info;
    await this.$store.dispatch('visitor/getVisitorArea', this.authorId);
    await this.$store.dispatch('visitor/getVisitorBuilding', this.authorId);
    await this.initLocalParams();
    if (this.info.visitorInterviewee.name && this.info.visitorInterviewee.workNum) {
      await this.getVisitorType();
      this.info.visitorInfoExtra.type && this.isEqual(this.info.visitorInfoExtra.type);
    }
  },
  mounted() {},
  methods: {
    initLocalParams() {
      const infoStore = localStorage.getItem('infoStore');
      if (!!infoStore && JSON.stringify(infoStore) !== '{}') {
        const initInfo = JSON.parse(infoStore);
        this.isEqual(initInfo.visitorInfoExtra.type); //若进入页面 isPark不更新  调用
        this.info = initInfo;
      }
    },
    setStore(val) {
      const infoStore = localStorage.getItem('infoStore');
      if (!infoStore) {
        localStorage.setItem('infoStore', JSON.stringify(val));
      } else {
        localStorage.removeItem('infoStore');
        localStorage.setItem('infoStore', JSON.stringify(val));
      }
    },
    goToAddCarsParking() {
      const val = this.initParams();
      this.setStore(val);
      this.$store.commit('visitor/updateVisitorApplyInfo', val);
      this.$router.push({ name: 'appointmentParking', query: { authorId: this.authorId } });
    },

    initParams() {
      const _this = this;
      const { visitorInfo } = this.info;
      const params = {
        ...this.info,
        visitorInfo: {
          ...visitorInfo,
          orgId: Number(_this.authorId),
        },
      };

      return params;
    },
    submit() {
      const { peers } = this.info;
      this.info.visitorInfo = peers[0];
      if (!this.auth()) return;
      if (!this.agree) {
        Toast(this.$t('appointment.visitors.agreementNotice'));
        return;
      }
      this.submitData();
    },
    submitData() {
      try {
        this.isLoading = true;
        Toast.loading({
          duration: 0,
          forbidClick: true,
          message: this.$t('empty.loading') + '...',
        });
        const _this = this;
        const { visitorInterviewee, visitorInfoExtra, visitorInfo, peers, cars } = this.info;
        const newPeer = peers.slice(1) || [];

        const visiterList = newPeer.map(i => {
          return {
            ...i,
            photo: i.photo[0].url,
            socialSecurityFile: !i.socialSecurityFile.length ? '' : i.socialSecurityFile[0].bizId,
          };
        });

        const newCars = [];
        cars &&
          cars.map((i, index) => {
            if (!!i.numberPlate || !!i.park) {
              if (!this.isPark) {
                // if (_this.info.visitorInfoExtra.type !== _this.carType) {
                newCars.push({ numberPlate: i.numberPlate, park: undefined });
              } else {
                index === 0 && newCars.push(i);
              }
            }
          });
        // if (_this.info.visitorInfoExtra.type == _this.carType) {
        //   this.info.cars = cars.map(i => ({ numberPlate: i.numberPlate, park: undefined }));
        // } else {
        //   this.info.cars = cars;
        // }
        const index = this.areaList.findIndex(i => i.id === visitorInfoExtra.deviceGroupId);
        const deviceGroupName = index !== -1 ? this.areaList[index].text : '';
        const typeIndex = this.defaultType.findIndex(i => i.type === visitorInfoExtra.type);
        const typeId = typeIndex !== -1 ? this.defaultType[typeIndex].id : null;

        // 预防本地的ids与当前的buildingList存在差异
        const deviceGroupsInBuildingList = this.buildingList.filter(i =>
          (visitorInfoExtra.deviceGroupIds || []).includes(i.id)
        );
        const deviceGroupIdsStr = deviceGroupsInBuildingList.map(i => i.id).join(';');
        const deviceGroupNamesStr = deviceGroupsInBuildingList.map(i => i.name).join(';');

        const params = {
          visitorInterviewee: {
            ...visitorInterviewee,
            workNum: visitorInterviewee.workNum,
          },
          visitorInfoExtra: {
            ...visitorInfoExtra,
            identityFile: !visitorInfoExtra.identityFile.length ? '' : visitorInfoExtra.identityFile[0].url,
            begin: moment(visitorInfoExtra.begin).valueOf(),
            end: moment(visitorInfoExtra.end).valueOf(),
            deviceGroupName,
            typeId,
            deviceGroupIds: deviceGroupIdsStr,
            deviceGroupNames: deviceGroupNamesStr,
          },
          visitorInfo: {
            ...visitorInfo,
            photo: visitorInfo.photo[0].url,
            socialSecurityFile: !visitorInfo.socialSecurityFile.length ? '' : visitorInfo.socialSecurityFile[0].bizId,
            tel: Number(visitorInfo.tel),
            // certificatesNumber: _this.info.visitorInfo.certificatesNumber,
            orgId: Number(_this.authorId),
          },
          peers: visiterList.length ? visiterList : undefined,
          cars: newCars.length ? newCars : undefined,
          // cars: this.info.cars,
        };

        api.postVisitorApply(params).then(res => {
          Toast.clear();
          this.isLoading = false;
          const [success] = res;
          if (success) {
            this.$router.push({ name: 'appointmentResult' });
          }
        });
      } catch (error) {
        console.log('error', error);

        Toast.clear();
        this.isLoading = false;
        Notify(i18n.tc(71250001));
      }
    },
    valid(peers) {
      if (!peers) return;

      return peers.map(i => {
        if (!i.name) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.name.tips'),
          });
          return false;
        }
        if (!i.photo) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.image.tips'),
          });
          return false;
        }
        if (!i.tel) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.phone.tips'),
          });
          return false;
        }
        if (i.tel) {
          const reg = /^1[3-9]\d{9}$/;
          if (!reg.test(i.tel)) {
            Notify({
              type: 'warning',
              message: this.$t('visitor.apply.phone.error.tips'),
            });
            return false;
          }
        }
        if (!i.certificatesType) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.card.type.tips'),
          });
          return false;
        }
        if (!i.certificatesNumber) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.idnumber.tips'),
          });
          return false;
        }
        if (i.certificatesNumber && i.certificatesType) {
          const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
          // const regPermit = /^8[123]0000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
          // const regPassport = /^([a-zA-z]|[0-9]){5,17}$/;

          if (i.certificatesType === 1 && !regIdCard.test(i.certificatesNumber)) {
            Notify({
              type: 'warning',
              message: this.$t('appointment.visitors.idcard.tips'),
            });
            return false;
          }
        }
        if (!i.socialSecurityFile || !i.socialSecurityFile.length) {
          Notify({
            type: 'warning',
            message: this.$t('appointment.visitors.social.security.certificate.files.tip'),
          });
          return false;
        }
        return true;
      });
    },
    auth() {
      const _this = this;
      const { visitorInterviewee, visitorInfoExtra, visitorInfo, peers } = this.info;
      // console.log('submit-valid-visitorInfo', visitorInfo, peers);

      if (!visitorInterviewee.name) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visited.name.tips'),
        });
        return false;
      }

      if (!visitorInterviewee.workNum) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visited.number.tips'),
        });
        return false;
      }
      if (!visitorInfoExtra.company) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visiting.company.tips'),
        });
        return false;
      }
      if (!visitorInfoExtra.reason) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visiting.reason.tips'),
        });
        return false;
      }
      if (!visitorInfoExtra.type) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visiting.type.tips'),
        });
        return false;
      }
      // if (this.isPark && !visitorInfoExtra.identityFile) {
      //   // if (visitorInfoExtra.type === this.carType && !visitorInfoExtra.identityFile) {
      //   Notify({
      //     type: 'warning',
      //     message: this.$t('appointment.visitors.files.tips'),
      //   });
      //   return false;
      // }

      if (!visitorInfoExtra.deviceGroupId) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visiting.area.tips'),
        });
        return false;
      }
      if (!visitorInfo.name) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visitors.name.tips'),
        });
        return false;
      }
      if (!visitorInfo.photo) {
        Notify({
          type: 'warning',
          message: this.$t('visitor.apply.avatar.tips'),
        });
        return false;
      }
      if (!visitorInfo.tel) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visitors.phone.tips'),
        });
        return false;
      }
      if (visitorInfo.tel) {
        const reg = /^1[3-9]\d{9}$/;
        if (!reg.test(visitorInfo.tel)) {
          Notify({
            type: 'warning',
            message: this.$t('visitor.apply.phone.error.tips'),
          });
          return false;
        }
      }
      if (!visitorInfo.certificatesType) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visitors.card.type.tips'),
        });
        return false;
      }
      if (!visitorInfo.socialSecurityFile || !visitorInfo.socialSecurityFile.length) {
        Notify({
          type: 'warning',
          message: this.$t('appointment.visitors.social.security.certificate.files.tip'),
        });
        return false;
      }
      const arrList = _this.valid(peers);
      const index = arrList.findIndex(i => i === false);
      if (index !== -1) {
        return false;
      }
      // if (!visitorInfo.certificatesNumber) {
      //   Notify({
      //     type: 'warning',
      //     message: this.$t('appointment.visitors.idnumber.tips'),
      //   });
      //   return false;
      // }
      // if (visitorInfo.certificatesNumber && visitorInfo.certificatesType) {
      //   const regIdCard = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      //   const regPermit = /^8[123]0000(?:19|20)\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])\d{3}[\dX]$/;
      //   const regPassport = /^([a-zA-z]|[0-9]){5,17}$/;

      //   if (visitorInfo.certificatesType === 1 && !regIdCard.test(visitorInfo.certificatesNumber)) {
      //     Notify({
      //       type: 'warning',
      //       message: this.$t('appointment.visitors.idcard.tips'),
      //     });
      //     return false;
      //   }
      //   if (visitorInfo.certificatesType === 2 && !regPermit.test(visitorInfo.certificatesNumber)) {
      //     Notify({
      //       type: 'warning',
      //       message: this.$t('appointment.visitors.permit.tips'),
      //     });
      //     return false;
      //   }
      //   if (visitorInfo.certificatesType === 3 && !regPassport.test(visitorInfo.certificatesNumber)) {
      //     Notify({
      //       type: 'warning',
      //       message: this.$t('appointment.visitors.passport.tips'),
      //     });
      //     return false;
      //   }
      // }
      return true;
    },
    isEqual(val) {
      console.log(this.defaultType);
      const _this = this;
      let index = _this.defaultType.findIndex(i => i.type === val);
      if (index !== -1) {
        this.isPark = _this.defaultType[index].isPark;
      }
    },
    async getVisitorType() {
      const params = {
        authorId: this.authorId,
        userName: this.info.visitorInterviewee.name,
        jobNumber: this.info.visitorInterviewee.workNum,
      };
      if (params.userName && params.jobNumber) {
        await this.$store.dispatch('visitor/getVisitorType', params);
      }
    },
  },

  beforeDestroy() {
    this.$store.commit('visitor/updateVisitorApplyInfo', this.info);
    const val = this.initParams();
    this.setStore(val);
  },
};
</script>

<style lang="less" scoped>
.apply {
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .visitingCarType {
    padding: 26px 0;
    .visitingTime,
    .visitingPark {
      font-size: 30px;
      // color: #949aa4;

      line-height: 30px;
      width: 100%;
      display: block;
      text-align: left;
    }
    .visitingPark {
      padding-top: 24px;
    }
  }
  .text-placeholder {
    color: #949aa4;
    font-size: 30px;
  }
  .info {
    height: 232px;
    .left {
      height: 100%;
      padding-left: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .logo {
        width: 180px;
        height: 90px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          max-width: 100%;
          max-height: 100%;
        }
      }

      span {
        font-size: 30px;
        color: #5d6067;
      }
    }
  }
  .form {
    margin-bottom: 158px;

    img {
      &.reviewMap {
        width: 38px;
        margin-right: 20px;
      }
    }
    .moduleTitle {
      font-size: 26px;
      text-align: left;
      text-indent: 20px;
      padding: 20px 0;
    }
    .addModuleTitle {
      padding: 20px 0 0 0;
    }
    .divider {
      height: 20px;
    }
  }
  .add {
    font-size: 30px;
    color: #00ccbf;
    text-align: right;
    padding: 20px 30px;
  }

  .dialogCon {
    padding: 30px;
    .title {
      font-size: 36px;
      color: #3d424d;
      letter-spacing: 0;
      text-align: center;
      line-height: 38px;
      margin-bottom: 70px;
    }
    .input {
      margin-bottom: 10px;
      input {
        background-color: rgba(0, 0, 0, 0.04);
        border-radius: 10px;
        padding: 0 15px;
        height: 75px;
        box-sizing: border-box;
      }
    }
  }
  .button {
    // position: fixed;
    height: 78px;
    bottom: 0;
    left: 0;
    right: 0;
    // background-color: white;
    padding: 0 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 120px;
    .buttonText {
      font-size: 36px;
    }
  }
}
.agreement-wrap {
  margin-bottom: 48px;
  display: flex;
  justify-content: center;
  /deep/ .van-checkbox__label {
    display: flex;
    align-items: center;
    font-size: 24px;
    color: #00ccbf;
  }
}
</style>
